import { render, staticRenderFns } from "./EmployeePersonalDetail.vue?vue&type=template&id=12a40b66&scoped=true&"
import script from "./EmployeePersonalDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeePersonalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a40b66",
  null
  
)

export default component.exports